import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import NProgress from 'nprogress'
import Home from '@/views/Home'
import List from './views/List.vue'
import NotFound from '@/views/NotFound'
import NetworkIssue from '@/views/NetworkIssue'
// import ListLocal from '@/views/ListLocal'
import PublicRecipe from '@/views/PublicRecipe'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
    // beforeEnter (routeTo, routeFrom, next) {
    //   // console.log('[router] home page beforeenter')
    //   next()
    // }
  },
  {
    path: '/recipes',
    name: 'recipes',
    meta: { requiresAuth: true },
    // If we have lists, go to the first one. Otherwise create new.
    beforeEnter (routeTo, routeFrom, next) {
      // console.log('[router] /lists beforeEnter')
      store.dispatch('loadLists')
        .then(lists => {
          // console.log('ll is ', ll)
          // const lists = store.state.lists
          // console.log('store.state.lists is', lists)
          if (lists.length > 0) {
          // if (lists != null && lists.length > 0) {
            const listId = lists[0].id
            // console.log('transitioning to: ', listId)
            next({
              path: '/recipes/' + listId
            })
          } else {
            console.log('/recipes going to new')
            next({ name: 'new' })
          }
        })
        .catch(error => {
          console.log('error in loadlists', error)
          next({ name: 'network-issue' })
        })
    }
  },
  {
    path: '/new',
    name: 'new',
    component: List,
    meta: { requiresAuth: true },
    beforeEnter (routeTo, routeFrom, next) {
      // console.log('[router] /new beforeEnter')
      store.dispatch('loadLists')
        .then(() => {
          store.dispatch('new')
            .then(listData => {
              // console.log('[router] - new got data: ', listData)
              next()
            })
            .catch(error => {
              console.log('got network error loadList', error)
              if (store.state.blockstack.user == null) {
                next('/')
              } else {
                next({ name: 'network-issue' })
              }
            })
        })
    }
  },
  {
    path: '/recipes/:id',
    component: List,
    props: true,
    meta: { requiresAuth: true }
    // before and update route guards are defined in component
  },
  {
    path: '/shared/:userId/:id',
    component: PublicRecipe,
    props: true
    // before and update route guards are defined in component
  },
  // {
  //   path: '/local',
  //   component: ListLocal,
  //   props: false,
  //   meta: { requiresAuth: false }
  // },
  {
    path: '/404',
    name: '404',
    component: NotFound,
    props: true
  },
  {
    path: '/network-issue',
    name: 'network-issue',
    component: NetworkIssue
  },
  {
    path: '*',
    redirect: { name: '404', params: { resource: 'page' } }
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})

router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const userSession = store.state.blockstack.userSession
    if (userSession) {
      if (!store.state.blockstack.userSession.isUserSignedIn()) {
        console.log('user not signed in')
        next({
          path: '/'
        })
      } else {
        next()
      }
    } else {
      next('/')
    }
    // if (store.state.blockstack.userSession.isUserSignedIn()) {
    //   console.log('user signed in')
    //   next()
    // } else {
    //   console.log('user not signed in')
    //   next({
    //     path: '/'
    //   })
    // }
  } else {
    next()
  }
})

router.beforeEach((routeTo, routeFrom, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
